import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import settings from 'common/configs/setting';
import timelineBg from 'assets/images/timeline-images/timeline-bg.png';

const getApiBase = () => {
    const url = localStorage.getItem('API_URL') || settings.url;
    return url.replace(/\/+$/, '');
};

const EmailChangeCancel = () => {
    const [loading, setLoading] = useState(true);
    const [statusText, setStatusText] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const hasFetched = useRef(false);

    useEffect(() => {
        let isMounted = true;
        if (hasFetched.current) {
            return;
        }
        hasFetched.current = true;

        const cancelEmailChange = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const token = params.get('token');

                if (!token) {
                    if (isMounted) {
                        setErrorMsg('Token is required.');
                        setLoading(false);
                    }
                    return;
                }

                const response = await axios.get(
                    `${getApiBase()}/api/v2/account/email-change/cancel/?token=${token}`
                );

                if (isMounted) {
                    setStatusText(
                        response.data?.message ||
                            'Email change request has been cancelled.'
                    );
                    setSuccess(true);
                }
            } catch (err) {
                if (isMounted) {
                    const errorMsgResponse = err.response?.data?.error;
                    if (
                        errorMsgResponse ===
                        "Cannot cancel request in 'cancelled' status."
                    ) {
                        setStatusText(
                            'This cancellation link has already been used. Your email address remains unchanged.'
                        );
                        setSuccess(true);
                    } else {
                        setErrorMsg(
                            errorMsgResponse ||
                                'An unexpected error occurred. Please try again.'
                        );
                    }
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        cancelEmailChange();
        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <>
            {/* JRNL's Native Background Layer */}
            <div className="bg-fill">
                <div
                    className="bg-fill__img"
                    style={{ backgroundImage: `url(${timelineBg})` }}
                />
            </div>
            <main id="login" className="access email-change__main">
                <div className="email-change__container email-change__container--wide">
                    {loading ? (
                        <>
                            <div className="access__title email-change__title--loading">
                                Cancelling Request...
                            </div>
                            <p className="email-change__text--muted">
                                Please wait while we process your request.
                            </p>
                        </>
                    ) : success ? (
                        <>
                            <div className="access__title email-change__title--success">
                                Email Change Cancelled
                            </div>
                            <p className="email-change__text">{statusText}</p>
                        </>
                    ) : (
                        <>
                            <div className="access__title email-change__title--error">
                                Link Invalid or Expired
                            </div>
                            <p className="email-change__text">{errorMsg}</p>
                        </>
                    )}
                </div>
            </main>
        </>
    );
};

export default EmailChangeCancel;
